import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { action } from 'satcheljs/lib/legacy';
import { lazySelectPersona, selectFavoriteCategory, selectFolder, selectGroup, } from 'owa-mail-folder-forest-actions';
/**
 * Selects the folder node
 * @param folderNode - the folder node to select
 * @param actionSource - the source that initiated the action
 */
export default action('selectFolderNode')(function selectFolderNode(folderNode, actionSource) {
    // VSO - #15945 - We should try to merge SelectFolder and SelectPersona logic
    var folderNodeToSelect = folderNode || getSelectedNode();
    switch (folderNodeToSelect.type) {
        case 1 /* Persona */:
            lazySelectPersona.importAndExecute(folderNodeToSelect.id);
            break;
        case 0 /* Folder */:
            selectFolder(folderNodeToSelect.id, folderNodeToSelect.treeType, actionSource);
            break;
        case 4 /* Category */:
            selectFavoriteCategory(folderNodeToSelect.id);
            break;
        case 2 /* Group */:
            selectGroup(folderNodeToSelect.id, folderNodeToSelect.treeType);
            break;
        default:
            throw new Error('selectFolderNode: Unknown node type');
    }
});
//# sourceMappingURL=selectFolderNode.js.map